export default function ratingToPriority(rating, { elementClass, isAga } = {}) {
  if (isAga) {
    if (rating === 5 || (rating === 4 && elementClass === 'primary')) return '1';
    if (rating === 4) return elementClass === 'non_structural' ? '3' : '2';
    if (rating === 3) return '3';
  }
  switch (rating) {
    case 0: default: return 'none';
    case 1: case 2: return '3';
    case 3: return '2';
    case 4: case 5: return '1';
  }
}
